// extracted by mini-css-extract-plugin
export default {"avatar":"lruk1","ny":"WDOqI","img":"OoVKw","square":"LQLht","icon":"OxE9o"};